module.exports = {
    local: 'http://localhost:5001',
    dev: 'http://chat.dev.i2g.cloud',
    prod: 'https://chat.i2g.cloud'
}
